import { entity } from 'jsonapi-transformers';

import { AbstractBibliographicResource } from './abstract-bibliographic-resource';

@entity({ type: 'resources' })
export class BibliographicResource extends AbstractBibliographicResource<BibliographicResource> {}
